import { render, staticRenderFns } from "./TournamentsOverviewPage.vue?vue&type=template&id=8fdbd3aa&scoped=true&"
import script from "./TournamentsOverviewPage.vue?vue&type=script&lang=js&"
export * from "./TournamentsOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./TournamentsOverviewPage.vue?vue&type=style&index=0&id=8fdbd3aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdbd3aa",
  null
  
)

export default component.exports